export default __webpack_public_path__ + "static/media/story_key_visual.5a43cb3b.png";